import { ReservationConfig } from "../../models/ReservationConfig";
import { getReservationConfig } from "./configActions";
import { SET_OPEN_FACILITY_SELECT } from "./configTypes";

export interface ConfigState {
  config: ReservationConfig;
  loading: boolean;
  openSelectFacility: boolean;
}

const initialConfig: ConfigState = {
  config: {} as ReservationConfig,
  loading: false,
  openSelectFacility: false,
};

export default function configReducer(configuration = initialConfig, action: any) {
  switch (action.type) {
    case getReservationConfig.pending.toString():
      return { ...configuration, loading: true };
    case getReservationConfig.fulfilled.toString():
      return { ...configuration, config: action.payload, loading: false };
    case getReservationConfig.rejected.toString():
      return { ...configuration, loading: false };
    case SET_OPEN_FACILITY_SELECT:
      return {
        ...configuration,
        openSelectFacility: action.payload,
      };
    default:
      return configuration;
  }
}
